"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _isString = _interopRequireDefault(require("../utils/isString"));
var _MenuButtonGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MenuButtonGroup.css") : void 0);
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-menu-button-group';
var MenuButtonGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var header = props.header,
    children = props.children,
    className = props.className,
    wrapperListItemProps = props.wrapperListItemProps,
    headerProps = props.headerProps,
    groupProps = __rest(props, ["header", "children", "className", "wrapperListItemProps", "headerProps"]);
  var classnames = _bind.default.bind(_MenuButtonGroup.default);
  var ariaLabelConstructor = function ariaLabelConstructor(content) {
    var ariaLabelContent;
    if (content) {
      if ((0, _isString.default)(content)) {
        ariaLabelContent = content;
      } else {
        var _context;
        ariaLabelContent = (0, _concat.default)(_context = "".concat((content === null || content === void 0 ? void 0 : content.title) || '')).call(_context, (content === null || content === void 0 ? void 0 : content.description) ? ", ".concat(content.description) : '');
      }
    }
    return ariaLabelContent;
  };
  var headerContent;
  if ((0, _isString.default)(header)) {
    headerContent = header;
  } else if ((header === null || header === void 0 ? void 0 : header.title) || (header === null || header === void 0 ? void 0 : header.description)) {
    headerContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header === null || header === void 0 ? void 0 : header.title, (header === null || header === void 0 ? void 0 : header.description) && ( /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(CSS_BLOCK, "__subtitle"))
    }, header.description)));
  }
  return /*#__PURE__*/_react.default.createElement("li", (0, _assign.default)({}, wrapperListItemProps, {
    role: "none",
    className: classnames(wrapperListItemProps === null || wrapperListItemProps === void 0 ? void 0 : wrapperListItemProps.className, "".concat(CSS_BLOCK, "__wrapper"))
  }), /*#__PURE__*/_react.default.createElement("ul", (0, _assign.default)({}, groupProps, {
    role: "group",
    "aria-label": ariaLabelConstructor(header),
    className: classnames(className, "".concat(CSS_BLOCK)),
    "data-nui-widgets": "menuitem-node",
    ref: ref
  }), headerContent && ( /*#__PURE__*/_react.default.createElement("li", (0, _assign.default)({}, headerProps, {
    role: "none",
    className: classnames(headerProps === null || headerProps === void 0 ? void 0 : headerProps.className, CSS_BLOCK, "".concat(CSS_BLOCK, "__header")),
    "data-nui-widgets": "menuitem-leaf"
  }), headerContent)), children));
});
MenuButtonGroup.displayName = 'MenuButtonGroup';
var _default = exports.default = MenuButtonGroup;